import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useNotify, Button, useDataProvider } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IUntagCreditNoteButton {
  commercialDocumentId: number;
  invoiceMbcRef: string;
}

const UntagCreditNoteButton = ({
  commercialDocumentId,
  invoiceMbcRef,
}: IUntagCreditNoteButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const notify = useNotify();
  const provider = useDataProvider();

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    cancelButton: {
      backgroundColor: "#eeeeee",
      color: "black",
    },
    button: {
      backgroundColor: "#ffbf00",
    },
  });

  const classes = useStyles();

  const handleUntagCreditNote = () => {
    setLoading(true);
    untagCreditNote();
  };

  const untagCreditNote = (retryCount: number = 1) => {
    provider
      .customPatch(`commercialDocuments/${commercialDocumentId}/untag`, {
        data: {},
      })
      .then(() => {
        setLoading(false);
        notify(`Successfully untag the credit note.`, "info");
        window.location.reload();
      })
      .catch((error: any) => {
        retryCount++;

        if (retryCount <= 3) {
          // give random delay between 2 - 3 seconds
          const delay = Math.floor(Math.random() * 1000) + 2000;
          setTimeout(() => {
            untagCreditNote(retryCount);
          }, delay);

          return;
        }

        notify(
          `Failed untag the credit note, error: ${error.message}`,
          "warning",
        );
        setLoading(false);
        return;
      });
  };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Untag
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          Untag Credit Note Confirmation
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure want to Untag this credit note {commercialDocumentId}{" "}
            from invoice {invoiceMbcRef} ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleUntagCreditNote}
            color="primary"
            undoable={false}
            label={loading ? `Loading...` : `Yes`}
            disabled={loading}
          />
          <Button
            onClick={handleClose}
            color="secondary"
            label="Cancel"
            className={classes.cancelButton}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default UntagCreditNoteButton;
